"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Policy_1 = require("./Policy");
class Credits120Policy extends Policy_1.Policy {
    meets(criteria) {
        return criteria.credits === 120;
    }
}
exports.default = new Credits120Policy();
